import { dayjsLondon, dayjsUtc, type Dayjs } from 'lib/dayjs'
import get from 'lodash/get'

type DateInput = Date | Dayjs | string | number | null | undefined

/** A YYYY-MM-DD date, which has no time */
const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/

/** Formats a date for people to read. A date with no time (YYYY-MM-DD) is
 * kept exactly as it is; anything else is shown in London time. */
export const formatDate = (
  date: DateInput,
  withTime?: boolean,
  formatOverwrite?: string
): string | null => {
  if (!date) return null

  const format =
    formatOverwrite || (withTime ? 'D MMMM YYYY, HH:mm' : 'D MMM YYYY')

  return typeof date === 'string' && DATE_ONLY.test(date)
    ? dayjsUtc(date).format(format)
    : dayjsLondon(date).format(format)
}

export const sortByDate = <T>(
  array: Array<T>,
  path: string | string[],
  order: 'asc' | 'desc' = 'asc'
): Array<T> => {
  if (!['asc', 'desc'].includes(order)) {
    throw new Error('Date order must be "asc" or "desc"')
  }

  const asc = array.sort((a, b) =>
    dayjsUtc(get(a, path)).diff(dayjsUtc(get(b, path)))
  )

  if (order === 'desc') return asc.reverse()

  return asc
}
